import ScrollMagic from 'scrollmagic';

export default {
  init() {
      /* eslint-disable no-unused-vars */
    // JavaScript to be fired on all pages
      var $hamburger = $('.hamburger');

       $('#openNav').on('click', function() {
          $hamburger.toggleClass('is-active');
          $('.nav.main-menu').toggleClass('menu-fadeout');
          $('.nav.main-menu').toggleClass('menu-fadein');
          $('body').toggleClass('-is-menu-open');
      });

      $('#closeNav').on('click', function() {
          //$hamburger.toggleClass('is-active');
        //   $('body').removeClass('-is-menu-open');
      });

      $('.search-header .input-group')
          .mouseenter(function() {
              $(this).css({'width':'100%','border':'1px solid #fff'});
         })
          .mouseleave(function() {
              $(this).css({'width':'21% ','border':'1px solid transparent'});
          });

      $('#play_audio').click(function() {
          var audio = $('#player');
          if (audio[0].paused == false) {
              audio[0].pause();
              //(this).removeClass('play');

          } else {
              audio[0].play();
              $(this).addClass('play');
          }
      });

      if ($('.header-2 .content-section').height() >= 700) {
          $('.header-2 .content-img').addClass(' d-flex justify-content-start align-items-center h-100');
      }

      $('#archives-dropdown-2').change(function(){
          if($(this).val() == ''){
              window.location.href = script_vars.page_for_posts;
          }
      });

      $('.banner-title p').wrapInner('<span>');

      $('.menu-search').click(function(event){
        event.preventDefault();
        $('input[name="s"]').val('');
        $('#searchModal').modal('toggle');
      });

      $('#searchModal').on('shown.bs.modal', function (e) {
        $( '#searchModal .search-field' ).focus();
      });

      if ($('.has-animation').length > 0){
          // Init ScrollMagic
          var controller = new ScrollMagic.Controller();

          // get all slides
          var slides = [];
          if ($('.has-widget-events').length > 0) {
               slides = ['#psa-item-1', '#psa-item-2'];
          } else {
               slides = ['#psa-item-1'];
          }

          // SCENE 1
          // add active class to each slide section
          slides.forEach(function(slide, index) {

              // number for highlighting scenes
              var num = index+1;

              // make scene
              var headerScene = new ScrollMagic.Scene({
                  triggerElement: slide,
                  offset: 0,
              })
                  .setClassToggle('#psa-item-'+num, 'is-active')  // set class to active slide
                  //.addIndicators()
                  .addTo(controller);
          });
      }

      // JS Template KodiagWebcam
      setInterval(function () {
        var container = document.getElementById('webcamContainer');
        var timestamp = new Date().getTime();

        // Buat image baru dengan query timestamp untuk bypass cache
        var newImg = document.createElement('img');
        newImg.id = 'webcamImage';
        newImg.src = 'https://koniagcam.s16.s360.is/webcam/current.jpg?t=' + timestamp;
        newImg.alt = 'Live Webcam';
        newImg.style.maxWidth = '100%';
        newImg.style.height = 'auto';

        // Ganti image lama dengan yang baru
        container.innerHTML = '';
        container.appendChild(newImg);
      }, 60000);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
      var back;
      var front;
      var investment_carousel;

      back = $('#slide-carousel').owlCarousel({
          loop:true,
          margin:0,
          nav:false,
          items: 1,
          dots: false,
          autoplay: true,
          autoplayTimeout: 5000,
          mouseDrag: false,
          touchDrag: false,
          animateOut: 'slideOutDown',
          animateIn: 'slideInDown',
      });

      front = $('#slide-content').owlCarousel({
          loop:true,
          margin:0,
          nav:false,
          items: 1,
          dots: true,
          mouseDrag: false,
          touchDrag: false,
          autoplay: true,
          autoplayTimeout: 5000,
          animateOut: 'slideOutDown',
          animateIn: 'slideInDown',

      });

      investment_carousel = $('#investment-carousel').owlCarousel({
            loop:true,
            margin:0,
            nav:false,
            items: 1,
            dots: true,
            mouseDrag: false,
            touchDrag: false,
            autoplay: true,
            autoplayTimeout: 5000,
        });

        function set_hegiht_quotes_wrapper() {
            var height_wrapper_investment = $('.wrapper-quotes .container').outerHeight();
            if(height_wrapper_investment > 348) {
                $('.image-carousel-investment').css({
                    'min-height' : height_wrapper_investment + 148,
                });
            }else {
                $('.image-carousel-investment').css({
                    'min-height' : 444,
                });
            }
        }
        set_hegiht_quotes_wrapper();

        $(window).on('resize', function(){
            set_hegiht_quotes_wrapper();
        });

        $('.menu-portofolio .menu-item').click(function(){

            $('html, body').animate({
                scrollTop: $('.menu-portofolio').offset().top,
            }, 1000)

            $('.menu-portofolio .menu-item').removeClass('active');
            $(this).addClass('active')

            $('.content-menu-portofolio .content-row').removeClass('active');
            $('.content-menu-portofolio .content-row .wrapper-content').removeClass('animate-up-content-portofolio');
            $('.content-menu-portofolio .content-row').addClass('d-none');

            var data_menu = $(this).attr('data-menu');
            $('.content-menu-portofolio .content-row.' + data_menu).removeClass('d-none');
            $('.content-menu-portofolio .content-row.' + data_menu + ' .wrapper-content').addClass('animate-up-content-portofolio');
            $('.content-menu-portofolio .content-row.' + data_menu).addClass('active');
        });

        var accordionpanel = $('.menu-portofoli-mobile .panel-group .panel');
        var accordionpanellength = accordionpanel.length;
        for( var i = 0 ; i < accordionpanellength; i++) {
            $('#collapse' + i).on('show.bs.collapse', function () {
                $(this).siblings('.panel-heading').children().children('.green-slider-mobile').addClass('active');
                $(this).siblings('.panel-heading').find('.fa-plus').addClass('rotate-icon');
            })

            $('#collapse' + i).on('shown.bs.collapse', function () {
                $(this).children('.panel-body').children('.container').addClass('active');
            })

            $('#collapse' + i).on('hidden.bs.collapse', function () {
                $(this).siblings('.panel-heading').children().children('.green-slider-mobile').removeClass('active');
            })

            $('#collapse' + i).on('hide.bs.collapse', function () {
                $(this).children('.panel-body').children('.container').removeClass('active');
                $(this).siblings('.panel-heading').find('.fa-plus').removeClass('rotate-icon');
            })
        }

        $('.wrapper-bio .green-slide .read-bio').click(function() {
            var biofull = $(this).attr('data-bio');
            $('.modal-teams .modal-body').html(biofull);
        });
        /*
        $('.page-team-data .wrapper-bio .name').click(function() {
            var biofull = $(this).attr('data-bio');
            $('.modal-teams .modal-body').html(biofull);
        });

        $('.page-leadership-data .wrapper-bio .name').click(function() {
            var biofull = $(this).attr('data-bio');
            $('.modal-teams .modal-body').html(biofull);
        });

        $('.modal-teams').on('show.bs.modal', function (e) {
            $('.modal-teams .modal-dialog').attr('class', 'modal-dialog  fadeIn  animated');
        });

        $('.modal-teams').on('hide.bs.modal', function (e) {
            $('.modal-teams .modal-dialog').attr('class', 'modal-dialog fadeOut animated');
        });
        */
        var accordionpanel2 = $('.record .panel-group .panel');
        var accordionpanellength2 = accordionpanel2.length;
        for( var j = 0 ; j < accordionpanellength2; j++) {
            $('#collapse' + j).on('show.bs.collapse', function () {
                $(this).siblings('.panel-heading').find('.fa-plus').addClass('rotate-icon');
                $(this).siblings('.panel-heading').find('.box-plus').addClass('active-orange');
                $(this).siblings('.panel-heading').find('a').addClass('active-bg-tale');
                $(this).siblings('.panel-heading').find('.wrapper-inner').addClass('active-color-white');
            })

            $('#collapse' + j).on('hide.bs.collapse', function () {
                $(this).siblings('.panel-heading').find('.fa-plus').removeClass('rotate-icon');
                $(this).siblings('.panel-heading').find('.box-plus').removeClass('active-orange');
                $(this).siblings('.panel-heading').find('a').removeClass('active-bg-tale');
                $(this).siblings('.panel-heading').find('.wrapper-inner').removeClass('active-color-white');
            })
        }

        $('.expand-btn a').click(function(e){
            e.preventDefault()

            if(!$(this).hasClass('collapse-btn')){
                var accordionpanel3 = $('.record .panel-group .panel');
                var accordionpanellength3 = accordionpanel3.length;
                var array_show = [];
                for(var k = 0; k < accordionpanellength3; k++) {
                    if($('#collapse' + k).hasClass('show') == false){
                        array_show.push(k)
                    }
                }

                for (var l = 0; l < array_show.length; l++) {
                    $('#collapse' + array_show[l]).siblings('.panel-heading').find('a').click();
                }

                $('.expand-btn').addClass('d-none');
                $('.collapse-btn').removeClass('d-none');
            }
        });

        $('.collapse-btn a').click(function(e){
            e.preventDefault()

            var accordionpanel4 = $('.record .panel-group .panel');
            var accordionpanellength4 = accordionpanel4.length;
            var array_show2 = [];
            for(var m = 0; m < accordionpanellength4; m++) {
                if($('#collapse' + m).hasClass('show') == true){
                    array_show2.push(m);
                }
            }

            for (var n = 0; n < array_show2.length; n++) {
                $('#collapse' + array_show2[n]).siblings('.panel-heading').find('a').click();
            }

            $('.collapse-btn').addClass('d-none');
            $('.expand-btn').removeClass('d-none');

        });


      // Sync nav
      back.on('click', '.owl-next', function () {
          front.trigger('next.owl.carousel');
          back.trigger('next.owl.carousel');
      });

      front.on('click', '.owl-dot', function () {
          var i = $(this).index();
          back.trigger('to.owl.carousel', [i, 500, true]);
          front.trigger('to.owl.carousel', [i, 500, true]);
      });


      $('a[href="#search-top"]').click(function() {
          $('html, body').animate({
              scrollTop: 0,
          }, 'slow');

          $('.search-header .input-group').css({'width':'100%','border':'1px solid #fff'});
          $('.search-header .input-group input' ).focus();
          return false;
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js